import { COLUMN_HEADER_KEYS } from "globals/constants";
import store from "store/store";


export const tenantSelectors = {
	tenant: (state = store.getState()) => state.tenant,
	tenantId: (state = store.getState()) => state.tenant.tenantId,
	awardFormColumnHeaders: (state = store.getState()) => state.tenant.formColumnHeaders[COLUMN_HEADER_KEYS.AWARD],
	proposalFormColumnHeaders: (state = store.getState()) => state.tenant.formColumnHeaders[COLUMN_HEADER_KEYS.PROPOSAL],
	projectFormColumnHeaders: (state = store.getState()) => state.tenant.formColumnHeaders[COLUMN_HEADER_KEYS.PROJECT],
	subawardFormColumnHeaders: (state = store.getState()) => state.tenant.formColumnHeaders[COLUMN_HEADER_KEYS.SUBAWARD],
	proposalCategories: (state = store.getState()) => state.tenant.categories.PROPOSAL,
	useFundingSchemeDictionary: (state = store.getState()) => state.tenant.useFundingSchemeDictionary,
};
